  <lib-carousel-widget 
    [items]="data.carouselSlides"
    [dropShadow]="data.dropShadow"
    [disableRoundness]="data.disableRoundness"
    [slidesPerView]="data.slidesPerView"
    [cardOrientation]="data.slidesOrientation"
    [border]="data.border"
    (navigateToContent)="navigateToContent($event)"
    (slideViewed)="slideViewed($event)">
  </lib-carousel-widget>
